import { TrashIcon } from "lucide-react";
import { DefaultActionBuilder } from "../types/actions";

export const actionDelete: DefaultActionBuilder = (
  onAction,
  options,
  hasConfirm?: boolean
) => {
  return {
    id: "delete",
    label: "Delete",
    icon: TrashIcon,
    allowInline: true,
    onAction,
    ...options,
    confirm:
      hasConfirm !== false
        ? {
            title: "Delete record",
            message:
              "Are you sure you want to delete this record? This action cannot be undone.",
            confirmButtonProps: {
              severity: "critical"
            },
            ...options?.confirm
          }
        : undefined
  };
};
